export const threadWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
};

export const threadListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  maxHeight: '420px',
  overflowY: 'auto',
};

export const emptyStyles = {
  padding: '16px 0',
  textAlign: 'center',
};

export const entryStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '12px 16px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const entryHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  flexWrap: 'wrap',
};

export const entryMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const entryBodyStyles = {
  whiteSpace: 'pre-wrap',
};

export const composerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  paddingTop: '12px',
};

export const composerActionsStyles = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '12px',
};

export const composerAudienceStyles = {
  minWidth: '180px',
};

// Keeps Send pinned right whether or not the audience picker renders.
export const composerSendButtonStyles = {
  marginLeft: 'auto',
  whiteSpace: 'nowrap',
};
